import type { SchemaField, SchemaSlotLayout } from '@cli-types/core-engine/schema.js'
import { slotAreaFields } from '@core-engine/schema/slot-layout/slot-area-fields.js'
import { normalizeFields } from './normalize-fields.js'

export function normalizeSlotLayoutFields(slot: SchemaSlotLayout): SchemaField[] {
  const { main, sidebar } = slotAreaFields(slot)
  return [...normalizeFields(main), ...normalizeFields(sidebar, 'sidebar')]
}
